import { PromocodeApplyStatus } from 'libs/pages/reservation/src/lib/types/PromocodeApplyStatus'
import { ReservationPromocodeStatus as Status } from 'libs/pages/reservation/src/lib/types/ReservationPromocodeStatus'
import { immer } from 'zustand/middleware/immer'
import { createWithEqualityFn as create } from 'zustand/traditional'
import { shallow } from 'zustand/vanilla/shallow'

import { Offer } from '@wwt/entities/search-response'

import { createSelectors } from '@/shared/lib/createSelectors'

interface State {
	offer: Offer | null
	promocodeId: string | null
	promocodeStatus: PromocodeApplyStatus
}

interface Actions {
	setOffer: (offer: Offer | null) => void
	updateOfferWWTOfferId: (wwtOfferId: string) => void
	setPromocodeId: (promocodeId: string | null) => void
	setPromocodeStatus: (status: PromocodeApplyStatus) => void
}

export const useReservationOfferStoreBase = create<State & Actions>()(
	immer(set => ({
		offer: null,
		promocodeId: null,
		promocodeStatus: { type: Status.INITIAL },
		setOffer: newOffer =>
			set(state => {
				state.offer = newOffer
			}),
		updateOfferWWTOfferId: wwtOfferId =>
			set(state => {
				if (!state.offer) {
					throw new Error('state.offer is not defined')
				}

				state.offer.IDs.wwtOfferId = wwtOfferId
			}),
		setPromocodeId: promocodeId =>
			set(state => {
				state.promocodeId = promocodeId
			}),
		setPromocodeStatus: status =>
			set(state => {
				state.promocodeStatus = status
			})
	})),
	shallow
)

export const useReservationOfferStore = createSelectors(
	useReservationOfferStoreBase
)
